<template>
  <div class="sp-page">
    <div class="page-header">
      <img class="header-img" src="@/assets/images/program/header-img.png" />
      <div class="header-title">news</div>
    </div>
    <div class="page-content">
      <div class="content-text">
        <div class="title">Introductions</div>
        <div class="text">
          World Federation of UNESCO Clubs, Centres and Associations (WFUCA) is a non-governmental
          organization in official partnership (associate status) with UNESCO having its office at
          Bonvin Building in Paris.
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="项目名称">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="举办时间">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item label="举办地点">
            <el-input v-model="formInline.user" placeholder=""></el-input>
          </el-form-item>
          <el-form-item>
            <el-link type="primary">Search</el-link>
          </el-form-item>
        </el-form>
      </div>
      <el-row :gutter="20" class="program-list">
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">The Co-Creation, an International Game of Art</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list-item">
            <div class="img-view">
              <img class="item-img" src="@/assets/images/program/list-item.png" />
            </div>
            <div class="item-title">
              The Co-Creation, an International Game of Arton, an International Game of on, an
              International Game of on, an International Game of
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="more-text">View More</div>
    </div>
  </div>
</template>
<script>
import strategy from "./components/strategy.vue";
import plan2025 from "./components/plan2025.vue";
import plan2029 from "./components/plan2029.vue";
import sustainable from "./components/sustainable.vue";
export default {
  components: {
    strategy,
    plan2025,
    plan2029,
    sustainable,
  },
  data() {
    return {
      activeName: "Strategy",
      constants: {},
      formInline: {},
    };
  },
  methods: {
    handleClick: () => {},
  },
};
</script>
<style scoped lang="scss">
.sp-page {
  width: 100%;
  .page-header {
    position: relative;
    img {
      width: 100%;
      display: block;
    }
    .header-title {
      position: absolute;
      left: fw(205vw, pc);
      bottom: fh(36vh, pc);
      font-size: fh(48vh, pc);
      color: #ffffff;
      line-height: fh(58vh, pc);
    }
  }
  .page-content {
    padding: fh(60vh, pc) fw(200vw, pc);
    .more-text {
      margin: 0 auto;
      font-size: fh(18vh, pc);
      color: #0077d4;
      width: max-content;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    .program-list {
      .list-item {
        padding-top: fh(20vh, pc);
        margin-bottom: fh(50vh, pc);
        margin-bottom: fh(20vh, pc);
        border-top: 1px solid #e4e4e4;
        height: fh(380vh, pc);
        overflow: hidden;
        .img-view {
          position: relative;
          width: 100%;
          height: fh(222vh, pc);
          overflow: hidden;
          img {
            position: absolute;
            width: 100%;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
          }
        }
        .item-title {
          margin: fh(20vh, pc) 0;
          font-size: fh(24vh, pc);
          line-height: fh(29vh, pc);
          color: #333;
          font-weight: bold;
          display: -webkit-box; /* 使用弹性盒模型布局 */
          -webkit-line-clamp: 4; /*显示的行数*/
          -webkit-box-orient: vertical; /* 垂直方向排列*/
          overflow: hidden;
          text-overflow: ellipsis; /* 超出部分显示省略号*/
          &:hover {
            cursor: pointer;
            color: #000;
          }
        }
      }
    }
    .content-text {
      .title {
        font-size: fh(36vh, pc);
        line-height: fh(54vh, pc);
        color: #333;
        font-weight: bold;
      }
      .text {
        font-size: fh(18vh, pc);
        line-height: fh(28vh, pc);
        color: #2a2a2a;
      }
    }
    ::v-deep .el-form {
      padding-top: fh(60vh, pc);
      padding-bottom: fh(80vh, pc);
      .el-form-item {
        margin-right: fw(20vw, pc);
        .el-input__inner {
          width: fw(288vw, pc);
          border-radius: 50px;
        }
      }
    }
  }
}
</style>
